import React from "react";

interface RaindropToggleProps {
  id: string;
  initialIsOn?: boolean;
  onToggle?: (newIsOn: boolean) => void;
  isDisabled?: boolean;
}

const RaindropToggle: React.FC<RaindropToggleProps> = ({
  id = "",
  initialIsOn = true,
  onToggle = (newIsOn) => {},
  isDisabled = false,
}) => {
  const [isOn, setIsOn] = React.useState(initialIsOn);

  let classSize = "h-8 w-16";

  let classIcon = "fas fa-xmark text-gray-400 text-sm";
  let classBackgroundOuter =
    "dark:bg-color-dark-background-tertiary bg-color-background-tertiary";
  let classBackgroundInner =
    "dark:bg-color-dark-background-secondary bg-color-background-secondary";
  let classTranslateX = "translate-x-0";
  let classOpacity = "opacity-100";
  let classPointer = "cursor-pointer";

  if (isOn) {
    classTranslateX = "translate-x-5";
    classIcon = "fas fa-check text-color-raindrop-primary text-sm";
    classBackgroundOuter = "bg-color-raindrop-primary";
  }

  if (isDisabled) {
    classOpacity = "opacity-30";
    classPointer = "cursor-default";
  }

  const onClick = () => {
    if (isDisabled) {
      return;
    }
    setIsOn(!isOn);
    onToggle(!isOn);
  };

  return (
    <div
      onClick={onClick}
      className={`flex rounded-full p-1 ${classPointer} ${classSize} ${classBackgroundOuter} ${classOpacity}`}
    >
      <div
        id={id}
        key={id}
        className={`flex flex-col items-center justify-center h-full aspect-square rounded-full transition-all duration-300 ${classBackgroundInner} ${classTranslateX}`}
      >
        <i className={classIcon}></i>
      </div>
    </div>
  );
};

export default RaindropToggle;
